import { get, globalPut } from "../index";

// DOES AN EXPORTED ISSUE REGISTER CARRY THE COST OF HOURS SPENT?
//
// Owner, 2026-10-06: "make the configuration on the project itself to
// include the cost or not". Per project, on top of the role gate - only a
// company administrator or a super admin sees cost on an export at all
// (back/utils/issueHours.canSeeCostOnExport), and only they may change this.
//
// `mayChange` comes from the server rather than being worked out here, so
// the control and the endpoint's own gate cannot drift apart.
export const getIssueExportCost = (projectId) =>
  get(`/projects/${projectId}/issue-export-cost`);

export const setIssueExportCost = (projectId, include) =>
  globalPut(`/projects/${projectId}/issue-export-cost`, { include }, false);
